const wrapMultimodule = <T, K = string | {}>(createModule: (key: K) => T) => {
    const _moduleRegistry: StringMap<T> = {};

    return (key: K) => {
        const keyStringified = JSON.stringify(key);

        if (!_moduleRegistry[keyStringified]) {
            _moduleRegistry[keyStringified] = createModule(key);
        }
        return _moduleRegistry[keyStringified];
    };
};

export const ModuleHelper = {
    wrapMultimodule,
};
